import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-verified-users" }
const _hoisted_2 = { class: "mb-5 flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex h-11 w-11 items-center justify-center rounded-xl bg-amber-50 text-amber-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_NotVerifiedUsersTableComponent = _resolveComponent("NotVerifiedUsersTableComponent")!
  const _component_CustomPaginationComponent = _resolveComponent("CustomPaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_v_icon, { size: "22" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-account-clock", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-right" }, [
          _createElementVNode("h2", { class: "text-lg font-bold text-slate-900" }, "کاربران احراز هویت نشده"),
          _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "بررسی مدارک و تعیین وضعیت درخواست‌ها")
        ], -1))
      ]),
      _createVNode(_component_ButtonComponent, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
        class: "min-w-[140px]",
        text: 'بازگشت به کاربران',
        status: 'primary'
      })
    ]),
    _createVNode(_component_NotVerifiedUsersTableComponent, {
      users: _ctx.getNotVerifiedUsers,
      onCheck: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleUserIdentify()))
    }, null, 8, ["users"]),
    (Number(_ctx.getGlobalPagination.total) > Number(_ctx.getGlobalPagination.limit))
      ? (_openBlock(), _createBlock(_component_CustomPaginationComponent, {
          key: 0,
          "total-items": _ctx.getGlobalPagination.total,
          "items-per-page": 50,
          onPageChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handelPagination()))
        }, null, 8, ["total-items"]))
      : _createCommentVNode("", true)
  ]))
}